import HttpService from "../base/HttpService";
export default class ReferenceService extends HttpService {
  static api = process.env.VUE_APP_BASE_API;

  getRefMaterial(param) {
    const api = this.api + "ref/material";
    return this.get(param, api);
  }

  getRefUid(param) {
    const api = this.api + "ref/instance/uid";
    return this.get(param, api);
  }

  getRefUidFilter(param) {
    const api = this.api + "ref/instance/uid-filter";
    return this.get(param, api);
  }

  getRefHolding(param) {
    const api = this.api + "ref/instance/holding-subs";
    return this.get(param, api);
  }

  getRefHoldingChild(param) {
    const api = this.api + "ref/instance/subs-hc";
    return this.get(param, api);
  }

  getRefUpUl(param) {
    const api = this.api + "ref/instance/up-ul";
    return this.get(param, api);
  }

  getPowerPlant(param) {
    const api = this.api + "ref/power-plant";
    return this.get(param, api);
  }

  getDirectorate(param) {
    const api = this.api + "ref/directorate";
    return this.get(param, api);
  }

  getRetailUnit(param) {
    const api = this.api + "ref/retail/unit";
    return this.get(param, api);
  }

  getManualBook() {
    const api = this.api + "ref/manual-book";
    return this.downloadPdf({}, api);
  }
}
